export const LOGINRADIUSCONFIG = {
    apidomain: "https://api.loginradius.com",
    apikey: `${window.APIKEY}`,
    refreshTokenTimeInMinutes: 15,
    kitchenerLoginRadiusURL: `${window.KITCHENERLOGINRADIUSURL}`,
    cloudLoginRadiusURL: "https://cloud-api.loginradius.com",
  };
  export const IDLETIMEOUT = isNaN(Number(window.IDLETIMEOUT))
    ? 15 * 60
    : Number(window.IDLETIMEOUT);
  export const DISPLAY_MESSAGES = {
    INVALID_USER: "Property details updated successfully.",
  };
  